import {gql} from 'apollo-boost';

export const GET_WEB_BOARD_REPLY = gql`
  query getWebBoardReply($id: ID!){
    getWebBoardReply(id: $id) {
      id teacherCode studentCode
      replyMessage picturePath email
      ip hitRate replyQty updatedAt
      teacher {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
      student {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
    }
  }
`;

export const GET_WEB_BOARD_REPLY_REPLIES = gql`
  query getWebBoardReplyReplies($id : ID!){
    getWebBoardReplyReplies (
      id: $id
    ) {
      id teacherCode studentCode
      replyMessage picturePath email
      ip hitRate replyQty updatedAt
      teacher {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
      student {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
    }
  }
`;

export const GET_WEB_BOARD_REPLY_REPLIES_BY_FILTER = gql`
  query getWebBoardReplyRepliesByFilter($webBoardReplyFilterInput: WebBoardReplyFilterInput){
    getWebBoardReplyRepliesByFilter (
      webBoardReplyFilterInput: $webBoardReplyFilterInput
    ) {
      id teacherCode studentCode
      replyMessage picturePath email
      ip hitRate replyQty updatedAt
      teacher {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
      student {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
    }
  }
`;

export const ADD_WEB_BOARD_REPLY = gql`
  mutation addWebBoardReply(
    $webBoardId: ID!,
    $postBy: String!,
    $webBoardReplyInput: WebBoardReplyInput!
  ) {
    addWebBoardReply(
      webBoardId: $webBoardId
      postBy: $postBy
      webBoardReplyInput: $webBoardReplyInput
    ) {
      id teacherCode studentCode
      replyMessage picturePath email
      ip updatedAt
      teacher {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
      student {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
    }
  }
`;

export const UPDATE_WEB_BOARD_REPLY = gql`
  mutation updateWebBoardReply(
    $id: ID!,
    $webBoardReplyInput: WebBoardReplyInput!
  ) {
    updateWebBoardReply(
      id: $id
      webBoardReplyInput: $webBoardReplyInput
    ) {
      id teacherCode studentCode
      replyMessage picturePath email
      ip updatedAt
      teacher {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
      student {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
    }
  }
`;

export const DELETE_WEB_BOARD_REPLY = gql`
  mutation deleteWebBoardReply($id: ID!) {
    deleteWebBoardReply(
      id: $id
    ) {
      id teacherCode studentCode
      replyMessage picturePath email
      ip updatedAt
      teacher {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
      student {
        id code picturePath
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng
      }
    }
  }
`;

